import React from 'react'
import RichText from '../../../shared/components/atoms/rich-text/rich-text'
import './return-button.scss'

const ReturnButton = ({ title = "VOLVER", href, ...params }) => {
  return (
    <a href={href} className="a-return-button" {...params}>
      <i className="icon-chevron-left"></i>{" "}{title}
    </a>
  )
}

export default ReturnButton
